import { Component, OnInit } from '@angular/core';
import { SignoGerenciasService } from 'src/app/components/entidades/gerencias/gerencias-service/gerencias.service';
import { SignoCentroMedicoService } from 'src/app/services/entidades/signo-centros-medicos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-centros-delete-by-gerenciadora',
  templateUrl: './centros-delete-by-gerenciadora.component.html',
  styleUrls: ['./centros-delete-by-gerenciadora.component.css']
})
export class CentrosDeleteByGerenciadoraComponent implements OnInit {

  gerenciadoras: any[] = [];
  selectedGerenciadoraId: string = '';
  totalCentros: number = 0;
  isLoadingCount: boolean = false;
  isDeleting: boolean = false;

  constructor(
    private gerenciaService: SignoGerenciasService,
    private centrosService: SignoCentroMedicoService
  ) { }

  ngOnInit(): void {
    this.loadGerenciadoras();
  }

  async loadGerenciadoras() {
    try {
      this.gerenciadoras = await this.gerenciaService.getGerencias();
    } catch (error) {
      console.error('Error cargando gerenciadoras', error);
    }
  }

  async onGerenciadoraChange() {
    if (!this.selectedGerenciadoraId) {
      this.totalCentros = 0;
      return;
    }

    this.isLoadingCount = true;
    try {
      // Obtenemos todos los centros y filtramos por la gerenciadora seleccionada para mostrar el conteo
      // Nota: Si el backend tuviera un countByGerenciadora id específico sería más eficiente, 
      // pero usaremos findAll y filtramos aquí por ahora.
      const centros = await this.centrosService.getCentroMedicos();
      this.totalCentros = centros.filter(c => {
         const gId = (c.gerenciadora && typeof c.gerenciadora === 'object') ? (c.gerenciadora as any)._id : c.gerenciadora;
         return gId === this.selectedGerenciadoraId;
      }).length;
    } catch (error) {
      console.error('Error contando centros', error);
    } finally {
      this.isLoadingCount = false;
    }
  }

  async deleteCentros() {
    if (!this.selectedGerenciadoraId || this.totalCentros === 0) return;

    const { value: confirmText } = await Swal.fire({
      title: '¿Estás seguro?',
      html: `Estás por eliminar <b>${this.totalCentros}</b> centros médicos.<br>Esta acción es <b>IRREVERSIBLE</b>.<br><br>Escribí <b>ELIMINAR</b> para confirmar:`,
      input: 'text',
      inputPlaceholder: 'Escribí ELIMINAR aquí',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: '🗑️ Sí, eliminar todo',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value || value.toUpperCase() !== 'ELIMINAR') {
          return 'Debés escribir ELIMINAR exactamente para continuar';
        }
        return null;
      }
    });

    if (confirmText && confirmText.toUpperCase() === 'ELIMINAR') {
      this.isDeleting = true;
      Swal.fire({
        title: 'Eliminando centros...',
        text: 'Por favor aguarde un momento',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        const deletedCount = await this.centrosService.deleteByGerenciadora(this.selectedGerenciadoraId);
        Swal.fire({
          icon: 'success',
          title: 'Eliminación Exitosa',
          text: `Se han eliminado ${deletedCount} centros médicos de la gerenciadora seleccionada.`,
          confirmButtonText: 'Ok'
        });
        this.selectedGerenciadoraId = '';
        this.totalCentros = 0;
      } catch (error) {
        console.error('Error al eliminar centros', error);
        Swal.fire('Error', 'No se pudieron eliminar los centros médicos.', 'error');
      } finally {
        this.isDeleting = false;
      }
    }
  }

}
